import _ from 'lodash'

const defaultSearchName = 'Default Search Name'
const allLocations = 'All Locations'
const mapBoundsText = 'Map Bounds'

/**
 * Conversion helpers
 */
export const arrayToStringRemovingSpaces = value =>
  value.join().replace(/-/g, '+').replace(/ /g, '-')

const truncateCoordinate = coordinate => {
  // we want to remove the decimals until we have only 1 in the coordinate without risking altering the value in any way
  const coordinateString = coordinate.toString()
  const [integerPart, decimalPart] = coordinateString.split('.')

  if (!decimalPart || decimalPart.length <= 1) {
    return coordinate
  }
  const truncatedDecimalPart = decimalPart[0]
  return parseFloat(`${integerPart}.${truncatedDecimalPart}`)
}

const mapBounds2Text = mapBounds => {
  const boundsString = mapBounds
    .map(mapBound => truncateCoordinate(mapBound))
    .join(', ')
  return `${mapBoundsText} (${boundsString})`
}

export const filter2Location = filters => {
  if (filters.globalSearch) {
    return allLocations
  }
  if (filters.mapBounds?.length) {
    return mapBounds2Text(filters.mapBounds)
  }

  const city = _.get(filters, 'city[0]')
  const county = _.get(filters, 'county[0]')
    ? `${filters.county[0]} County`
    : null
  const state = _.get(filters, 'state[0]')
  const zip = _.get(filters, 'zip[0]')
  return _.join(_.compact([city, county, state, zip]), ', ')
}

export const getDefaultSaveSearchNameFromFilters = filters => {
  return filter2Location(filters) || filters.search || defaultSearchName
}
